import Api from "@/api";

export default class PrintersApi extends Api {
  async addPrinterToGroup(printerId, groupId) {
    return this.client.put(`/print_groups/${groupId}/add_printer`, {
      printer_id: printerId,
    });
  }

  async removePrinterFromGroup(printerId, groupId) {
    return this.client.put(`/print_groups/${groupId}/remove_printer`, {
      printer_id: printerId,
    });
  }

  async retrieveServers() {
    return this.client.get("/print_servers");
  }

  async retrievePrintGroupPrinters(printGroupId) {
    return this.client.get(`/print_groups/${printGroupId}/printers.json`);
  }

  async retrievePrintGroups(catalogueId) {
    return this.client.get(`/catalogues/${catalogueId}/print_groups`);
  }

  async retrievePrintGroup(id) {
    return this.client.get(`/print_groups/${id}`);
  }

  async createPrintGroup(catalogueId, printGroup) {
    return this.client.post(`/catalogues/${catalogueId}/print_groups`, {
      description: printGroup.description,
    });
  }

  async updatePrintGroup(id, printGroup) {
    return this.client.put(`/print_groups/${id}`, printGroup);
  }

  async deletePrintGroup(id) {
    return this.client.delete(`/print_groups/${id}`);
  }

  async createCatalogue(catalogue) {
    return this.client.post("/catalogues", catalogue);
  }

  async updateCatalogue(id, catalogue) {
    return this.client.put(`/catalogues/${id}`, catalogue);
  }

  async listCatalogues() {
    return this.client.get("/catalogues");
  }

  async retrieveCatalogue(id) {
    return this.client.get(`/catalogues/${id}`);
  }

  async deleteCatalogue(catalogueId) {
    return this.client.delete(`/catalogues/${catalogueId}`);
  }

  async deleteServer(serverId) {
    return this.client.delete(`/print_servers/${serverId}`);
  }

  async updateServer(id, server) {
    return this.client.put(`/print_servers/${id}`, server);
  }

  async createServer(server) {
    return this.client.post("/print_servers", server);
  }

  async addPrinter(serverId, printer) {
    return this.client.post(`/print_servers/${serverId}/printers`, printer);
  }

  async retrievePrinter(id) {
    return this.client.get(`/printers/${id}`);
  }

  async updatePrinter(id, printer) {
    return this.client.put(`/printers/${id}`, printer);
  }

  async retrievePrinterDimensions(id) {
    return this.client.get(`/printers/${id}/dimensions`);
  }

  async deleteDimension(id) {
    return this.client.delete(`/dimensions/${id}`);
  }

  async createDimension(printerId, dimension) {
    return this.client.post(`printers/${printerId}/dimensions`, dimension);
  }

  async retrieveServer(id) {
    return this.client.get(`/print_servers/${id}`);
  }

  async retrievePrinters(serverId) {
    return this.client.get(`/print_servers/${serverId}/printers`);
  }
}



// WEBPACK FOOTER //
// ./src/printers_api.js